export default __webpack_public_path__ + "static/media/CommunityPartner_Thumbnail.2310bc49.png";